import { IconComponent } from '../icon.types';

export const GooglePlayIcon: IconComponent = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.45184 0.380095C2.13791 0.743411 1.97774 1.21044 2.0041 1.68558V22.3122C1.97168 22.7881 2.1326 23.2573 2.45184 23.6177L2.51852 23.6923L14.3216 12.1388V11.859L2.51852 0.314819L2.45184 0.380095Z"
      fill="currentColor"
    />
    <path
      d="M18.2276 15.9899L14.3218 12.1387V11.859L18.2276 8.00781L18.3133 8.06376L22.9907 10.6561C24.3244 11.3927 24.3244 12.605 22.9907 13.351L18.3324 15.9433L18.2276 15.9899Z"
      fill="currentColor"
    />
    <path
      d="M18.3416 15.934L14.3215 11.9989L2.45166 23.6177C2.72085 23.8522 3.06541 23.9872 3.42559 23.9991C3.78576 24.011 4.13885 23.8992 4.42361 23.683L18.3416 15.934Z"
      fill="currentColor"
    />
    <path
      d="M18.3416 8.06383L4.42361 0.324174C4.1407 0.10496 3.78789 -0.00960236 3.42722 0.000630724C3.06656 0.0108638 2.72112 0.145238 2.45166 0.380125L14.3215 11.9989L18.3416 8.06383Z"
      fill="currentColor"
    />
    <path
      opacity="0.25"
      d="M4.42335 0.454739L22.9902 10.7867C23.2437 10.8972 23.4672 11.0645 23.6426 11.2751C23.818 11.4856 23.9404 11.7336 23.9999 11.9989C23.9705 11.7069 23.8612 11.4281 23.6835 11.1918C23.5058 10.9555 23.2663 10.7704 22.9902 10.6562L4.42335 0.324189C3.09919 -0.421801 2.00366 0.193642 2.00366 1.68562V1.8255C2.03224 0.333515 3.09919 -0.281927 4.42335 0.454739Z"
      fill="currentColor"
    />
  </svg>
);
